import BongInputPage from "../components/BongInputPage";

export default function TipsPage() {
  return <BongInputPage role="tips" defaultName="Tipsekspert" stateKey="bong_data" />;
}
